import React, { useEffect, useState } from "react";
import { Row, Col, Table, Button, Badge, Spinner,  } from "react-bootstrap";
import { endpoint } from "../../utils/api";
import SectionModal from "./SectionModal";

//Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileImport, faEdit } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(faFileImport, faEdit)


const SectionsTable = ({ sections, update, setSectionID, setOpenNewModal, chosenDepartment}) => {

  const [IDLoading, setIDLoading] = useState("");

  const click = async (id) => {

    return Word.run(async (context) => {
      let url = endpoint + "/sections/section/import/" + id;
      fetch(url, 
        {
          headers: {
             Authorization: 'Bearer '+ localStorage.token,
             DepartmentName: chosenDepartment
         }
        }).then(function async(response) {
        response.json().then(function (data) {
          let text = Buffer.from(data.file, "hex").toString("utf8");
          context.document.getSelection().insertOoxml(text, "End");      
          context.sync();
          setIDLoading("");
        });
      });
    });
  };
 
  return (
    <Table striped bordered hover>
   
      <thead>
        <tr>
          <th>Name</th>
          <th>Description</th>
          <th>Tags</th>
          <th>{update ? "Update" : "Insert" }</th>
        </tr>
      </thead>
      <tbody>
        {Object.keys(sections).map((section) => {
          return (
            <tr>
              
              <td>{sections[section].name}</td>
              <td>{sections[section].description}</td>
              <td>
                {sections[section].tags.map((tag) => {
                  return (
                    <>
                      <Badge bg="secondary">{tag}</Badge>{" "}
                    </>
                  );
                })}
              </td>
              {/* <td>{(sections[section].updatedAt).slice(0,10).split("-").reverse().join('/')}</td>
              {/* <td>{Object.keys(users).map(user => {
                  if (users[user]._id === sections[section].last_updated_by){
                      return users[user].name
                  }
                })}</td> */}
              <td>
                {update ? 
                <Button 
                  variant="light" 
                  onClick={() => {setOpenNewModal(true); setSectionID(sections[section]._id)}}
                  >
                   <FontAwesomeIcon 
                      icon={faEdit}  
                      size='1x' 
                      className='all-font-icons' 
                    />
                  </Button> 
                : 
                <Button className="insert-button primary-button border-button" onClick={() => {click(sections[section]._id); setIDLoading(sections[section]._id)}} disabled={sections[section]._id === IDLoading}>

                   {sections[section]._id !== IDLoading ? 
                    <FontAwesomeIcon icon={faFileImport}  size='1x' className='all-font-icons' />
                    :
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        variant="light"
                    />
                    }
                </Button>
                }
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
    
  );
};

export default SectionsTable;
